import { useNavigate, useLocation } from 'react-router-dom';
import { getLocaleFromPath, localizePath } from '@/utils/locale';

/** 在 pagesEn 或英文路由下自动为 navigate 目标添加 /en 前缀 */
export const useLocalizedNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locale = getLocaleFromPath(location.pathname);

  return (to, options) => {
    if (typeof to === 'string') {
      navigate(localizePath(to, locale), options);
    } else {
      navigate(to, options);
    }
  };
};
